import React, { Component } from 'react';
import { Form, Button, Card } from 'tabler-react';
import { NotificationManager } from 'react-notifications';
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import * as conf from '../../config/config';

const api_raiz = conf.api_raiz;
const user = JSON.parse(sessionStorage.getItem('usuario'));

class RechazarServicio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      motivoRechazo: '',
    };
  }

  handleMotivoChange = (event) => {
    this.setState({ motivoRechazo: event.target.value });
  };

  handleSubmit = async () => {
    if (!this.state.motivoRechazo) {
      NotificationManager.warning('Por favor seleccione un motivo de rechazo');
      return;
    }
    
    const movimiento = this.props.movimiento || (this.props.datosForm && this.props.datosForm.movimiento);
    const refrescar = this.props.refrescar || (this.props.datosForm && this.props.datosForm.refrescar);
    
    if (!movimiento || !movimiento.idMovimiento) {
      NotificationManager.error('No se encontraron datos del movimiento');
      return;
    }

    const idMovimiento = movimiento.idMovimiento;
    const motivoMap = { '1': 23, '2': 25, '3': 26 };
    const codigoMotivo = motivoMap[this.state.motivoRechazo];

    try {
      // API 1: Cambiar estatus a 3
      await Crud_Catalogos(
        `navieraMovimientos/movimiento/${idMovimiento}/operacionestatus/3`,
        '',
        'put'
      );

      // API 2: Enviar correo según motivo
      await Crud_Catalogos(
        `mail/arrobanaviera/${idMovimiento}/${codigoMotivo}`,
        '',
        'post'
      );

      // Log de auditoría
      const logData = {
        nombreCatalogo: 'NavieraMovimientos',
        usuario: user ? user.persona : 0,
        accionFecha: null,
        metodo: 'put',
        data: JSON.stringify({
          idMovimiento,
          motivoRechazo: this.state.motivoRechazo,
          codigoMotivo,
          accion: 'Rechazo de servicio'
        }),
        request: JSON.stringify({ idMovimiento, operacionEstatus: 3 }),
        error: ''
      };
      await Crud_Catalogos('catalogosLog', '', 'post', '', logData);

      NotificationManager.success('Servicio rechazado correctamente');
      
      // Refrescar la tabla
      if (refrescar) {
        refrescar();
      }
      
      this.handleCancel();
    } catch (error) {
      console.error('Error al rechazar servicio:', error);
      NotificationManager.error('Error al rechazar el servicio');
    }
  };

  handleCancel = () => {
    if (this.props.cerrarModal) {
      this.props.cerrarModal();
    }
  };

  render() {
    return (
      <div className="container-fluid p-4">
        <Card>
          <Card.Body>
            <div className="mb-4">
              <p className="text-muted text-center">
                Seleccione el motivo por el cual se rechaza el servicio para este movimiento
              </p>
            </div>
            
            <Form.Group>
              <div className="form-selectgroup form-selectgroup-boxes d-flex flex-row gap-3">
                <label className="form-selectgroup-item flex-fill">
                  <input
                    type="radio"
                    name="motivoRechazo"
                    value="1"
                    className="form-selectgroup-input"
                    checked={this.state.motivoRechazo === '1'}
                    onChange={this.handleMotivoChange}
                  />
                  <div className="form-selectgroup-label text-center p-3">
                    <strong>Fuera de zona de cobertura Skyangel</strong>
                  </div>
                </label>
                
                <label className="form-selectgroup-item flex-fill">
                  <input
                    type="radio"
                    name="motivoRechazo"
                    value="2"
                    className="form-selectgroup-input"
                    checked={this.state.motivoRechazo === '2'}
                    onChange={this.handleMotivoChange}
                  />
                  <div className="form-selectgroup-label text-center p-3">
                    <strong>Sin disponibilidad de equipo especial en esa localidad</strong>
                  </div>
                </label>
                
                <label className="form-selectgroup-item flex-fill">
                  <input
                    type="radio"
                    name="motivoRechazo"
                    value="3"
                    className="form-selectgroup-input"
                    checked={this.state.motivoRechazo === '3'}
                    onChange={this.handleMotivoChange}
                  />
                  <div className="form-selectgroup-label text-center p-3">
                    <strong>Fuera de horario de cobertura</strong>
                  </div>
                </label>
              </div>
            </Form.Group>

            <div className="d-flex justify-content-end mt-4">
              <Button 
                color="secondary" 
                outline 
                onClick={this.handleCancel}
                className="me-3"
              >
                Cancelar
              </Button>
              <Button 
                color="danger" 
                onClick={this.handleSubmit}
                disabled={!this.state.motivoRechazo}
              >
                Rechazar Servicio
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default RechazarServicio;
